import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function NotFound() {
  return (
    <div className="container max-w-screen-md py-16 text-center">
      <div className="text-7xl font-display italic text-muted-foreground">404</div>
      <h1 className="text-xl font-semibold mt-3">Route not found</h1>
      <p className="text-sm text-muted-foreground mt-1">The page you’re looking for doesn’t exist or you don’t have access.</p>
      <Button asChild variant="primary" className="mt-5">
        <Link to="/">Go home</Link>
      </Button>
    </div>
  );
}
